// extracted by mini-css-extract-plugin
module.exports = {"modalSuccess__title":"ModalSuccess_modalSuccess__title__3h7J-"};